export default function BooleanCell({
    value,
}: {
    value: string,
}) {
    return (
        <div className="flex justify-center items-center gap-2">
            <div className={`w-[12px] rounded-full aspect-square ${value === 'true' ? 'bg-[#7BC960]' : 'bg-[#FF8484]'}`} />
            <p className="text-[14px] text-nowrap font-medium text-default">{value === 'true' ? 'True' : 'False'}</p>
        </div>
    )
}